import { connect } from 'react-redux'

import { searchWopi360Targets, deleteWopi360Target } from '../../ducks/wopi360-targets-admin'
import Wopi360TargetList from '../Wopi360TargetList'

export default connect(
  state => ({
    currentLanguage: state.account.get('currentLanguage'),
    wopi360Targets: state.wopi360TargetsAdmin.get('wopi360Targets'),
    closedWopi360Target: state.wopi360TargetsAdmin.get('closedWopi360Target'),
    deletedWopi360Targets: state.wopi360TargetsAdmin.get('deletedWopi360Targets'),
    searchFilters: state.wopi360TargetsAdmin.get('searchFilters'),
    pagination: state.wopi360TargetsAdmin.get('pagination'),
    token: window.localStorage.getItem('token')
  }),
  {
    onSearch: searchWopi360Targets,
    onDelete: deleteWopi360Target
  }
)(Wopi360TargetList)



// WEBPACK FOOTER //
// ./src/components/smart/Wopi360TargetListContainer.js